import React from "react";

const Chevron = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33285 2.74446C6.53285 2.74446 6.73285 2.81113 6.86618 3.01113L11.8662 8.01116C12.1995 8.3445 12.1995 8.81116 11.8662 9.1445L6.86618 14.1445C6.53285 14.4779 6.06617 14.4779 5.73284 14.1445C5.3995 13.8112 5.3995 13.3445 5.73284 13.0112L10.2662 8.5445L5.79951 4.0778C5.46617 3.74447 5.46617 3.2778 5.79951 2.94446C5.93284 2.81113 6.13284 2.74446 6.33285 2.74446Z"
        fill="#6F727A"
      />
    </svg>
  );
};

export default Chevron;
